import gql from 'graphql-tag';

export const CREATE_CHAT = gql`
  mutation CreateChat($data: CreateChatInput) {
    createChat(data: $data) {
      ... on CreateChat {
        message
        version
        chat {
          id
          account_id
          client_account_id
          appointment_id
          estimate_id
          job_id
          invoice_id
          chatType
          name
          clientAccountName
          clientUserFullName
          lastMessageText
          lastMessageDateTime
          lastMessageUserId
          lastMessageUserAccountName
          lastMessageUserFirstName
          lastMessageUserLastName
          lastMessageUserAvatarUrl
          spLastReadDateTime
          spHasUnreadMessages
          spUnreadMessageCount
          clientLastReadDateTime
          clientHasUnreadMessages
          clientUnreadMessageCount
          messages {
            id
            chat_id
            sender_user_id
            sender_account_id
            recipient_account_id
            estimate_id
            job_id
            invoice_id
            senderFirstName
            senderLastName
            senderAvatarUrl
            senderAccountName
            attachments {
              id
              job_id
              account_id
              creator_user_id
              creatorFullName
              client_account_id
              service_item_id
              estimate_id
              property_id
              note_id
              message_id
              invoice_id
              fileName
              fileSize
              mimeType
              base64
              isInternal
              type
              createdAt
              updatedAt
            }
            text
            isInternal
            isArchived
            createdAt
            updatedAt
          }
          isArchived
          isArchivedClientAccount
          isArchivedServiceProviderAccount
          createdAt
          updatedAt
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const UPDATE_CHAT = gql`
  mutation UpdateChat($data: UpdateChatInput!) {
    updateChat(data: $data) {
      ... on UpdateChat {
        message
        version
        chat {
          id
          account_id
          client_account_id
          appointment_id
          estimate_id
          job_id
          invoice_id
          chatType
          name
          clientAccountName
          clientUserFullName
          lastMessageText
          lastMessageDateTime
          lastMessageUserId
          lastMessageUserAccountName
          lastMessageUserFirstName
          lastMessageUserLastName
          lastMessageUserAvatarUrl
          spLastReadDateTime
          spHasUnreadMessages
          spUnreadMessageCount
          clientLastReadDateTime
          clientHasUnreadMessages
          clientUnreadMessageCount
          messages {
            id
            chat_id
            sender_user_id
            sender_account_id
            recipient_account_id
            estimate_id
            job_id
            invoice_id
            senderFirstName
            senderLastName
            senderAvatarUrl
            senderAccountName
            attachments {
              id
              job_id
              account_id
              creator_user_id
              creatorFullName
              client_account_id
              service_item_id
              estimate_id
              property_id
              note_id
              message_id
              invoice_id
              fileName
              fileSize
              mimeType
              base64
              isInternal
              type
              createdAt
              updatedAt
            }
            text
            isInternal
            isArchived
            createdAt
            updatedAt
          }
          isArchived
          isArchivedClientAccount
          isArchivedServiceProviderAccount
          createdAt
          updatedAt
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const CREATE_MESSAGE = gql`
  mutation CreateMessage($data: CreateMessageInput) {
    createMessage(data: $data) {
      ... on CreateUpdateMessage {
        message
        version
        messageData {
          id
          chat_id
          sender_user_id
          sender_account_id
          recipient_account_id
          estimate_id
          job_id
          invoice_id
          senderFirstName
          senderLastName
          senderAvatarUrl
          senderAccountName
          attachments {
            id
            job_id
            account_id
            creator_user_id
            creatorFullName
            client_account_id
            service_item_id
            estimate_id
            property_id
            note_id
            message_id
            invoice_id
            fileName
            fileSize
            mimeType
            base64
            isInternal
            type
            createdAt
            updatedAt
          }
          text
          isInternal
          isArchived
          createdAt
          updatedAt
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const UPDATE_MESSAGE = gql`
  mutation UpdateMessage($data: UpdateMessageInput) {
    updateMessage(data: $data) {
      ... on CreateUpdateMessage {
        message
        version
        messageData {
          id
          chat_id
          sender_user_id
          sender_account_id
          recipient_account_id
          estimate_id
          job_id
          invoice_id
          senderFirstName
          senderLastName
          senderAvatarUrl
          senderAccountName
          attachments {
            id
            job_id
            account_id
            creator_user_id
            creatorFullName
            client_account_id
            service_item_id
            estimate_id
            property_id
            note_id
            message_id
            invoice_id
            fileName
            fileSize
            mimeType
            base64
            isInternal
            type
            createdAt
            updatedAt
          }
          text
          isInternal
          isArchived
          createdAt
          updatedAt
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const DELETE_MESSAGE = gql`
  mutation DeleteMessage($deleteMessageId: ID!) {
    deleteMessage(id: $deleteMessageId) {
      ... on DeleteMessage {
        message
        version
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const SEND_TYPING_INDICATOR = gql`
  mutation SendTypingIndicator($data: SendTypingIndicatorInput!) {
    sendTypingIndicator(data: $data) {
      ... on SendTypingIndicator {
        message
        version
        success
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const DELETE_ATTACHMENT = gql`
  mutation DeleteAttachment($id: ID!) {
    deleteAttachment(id: $id) {
      __typename
      ... on DeleteAttachment {
        message
        version
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;
